export default "__VITE_ASSET__BXEog8gO__"